import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { HomeState } from "./types";

export const state: HomeState = {
  userId: localStorage.user ? JSON.parse(localStorage.user).id : "",
  resumeDataCache: {},
};

const namespaced: boolean = true;

export const home: Module<HomeState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
